import { AuthError } from '@azure/msal-browser';

export const extractErrorMessage = (err, fallback = 'Something went wrong. Please try again.') => {
  const data = err?.response?.data;
  let message = fallback;
  if (data) {
    if (data.errors && typeof data.errors === 'object') {
      const msgs = Object.values(data.errors).flat();
      message = msgs.length ? msgs.join(' ') : (data.title || message);
    } else if (data.title) {
      message = data.title;
    } else if (data.errorMessage) {
      message = data.errorMessage;
    } else if (data.message && typeof data.message === 'string') {
      message = data.message;
    } else if (data.error && typeof data.error === 'string') {
      message = data.error;
    } else if (typeof data === 'string' && data.length < 300) {
      message = data;
    }
  } else if (err?.message && !(err instanceof AuthError)) {
    // MSAL AuthError.message is an internal 'errorCode: description...' string, not safe to show users.
    message = err.message;
  }
  return message;
};
